import { FC } from "react";
import { PlatformReview } from "../../../domain/models/PlatformReviews";
import QuotesIconSVG from "../../resources/svg/QuotesIconSVG";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";

interface ReviewCardProps {
    review: PlatformReview;
    className?: string;
}

const ReviewCard: FC<ReviewCardProps> = (props) => {
    const { upTo650, moreOrEqual650 } = useScreenSize();

    return (
        <div className={`relative ${props.className}`}>
            <div className="relative flex flex-col bg-backgroundInput rounded-[10px] py-8 tmax4:py-5 px-9 td4:px-5 tmax4:px-4 max-w-[845px]">
                <div className="flex flex-col items-start w-full mb-8 tmax4:mb-5">
                    <div className="flex dmin2:H20B td4:H20B tmax4:H16B text-textWhite text-start mb-4 tmax4:mb-3">
                        {props.review.title}
                        <QuotesIconSVG />
                    </div>
                    <div className="flex items-end">
                        <span className="H16 dmax2:H14 text-textWhite">{props.review.description}</span>
                    </div>
                </div>
                <div className="flex justify-between items-end">
                    <div className="flex items-center gap-4">
                        <div className="relative w-[62px] min-w-[62px] dmax2:w-[46px] dmax2:min-w-[46px] h-[62px] min-h-[62px] dmax2:h-[46px] dmax2:min-h-[46px]">
                            <img
                                src={props.review.user.profileImage.filePath}
                                alt="user"
                                className="rounded-full object-cover w-full h-full"
                            />
                        </div>
                        <div className="H16B dmax2:H14B text-textWhite">{`${props.review.user.firstName} ${props.review.user.lastName}, ${props.review.user.jobTitle}`}</div>
                    </div>
                    {moreOrEqual650 && <div className="H16 tmax4:H14 text-textFaded">{props.review.createdAt}</div>}
                </div>
                {upTo650 && <div className="H16 tmax4:H14 text-textFaded text-end mt-1">{props.review.createdAt}</div>}
            </div>
        </div>
    );
};

export default ReviewCard;
